<template>
  <section class="organism-social-proof">
    <h1 class="main-title">Trusted by teams who fly for serious work</h1>
    <p class="vision-description">
      See how professionals use Skyhost to transform their operations.
    </p>
    <div class="testimonials-grid">
      <TestimonialCard
        v-for="(testimonial, index) in testimonials"
        :key="index"
        :quote="testimonial.quote"
        :name="testimonial.name"
        :title="testimonial.title"
      />
    </div>
  </section>
</template>

<script>
import TestimonialCard from "@/components/molecules/TestimonialCard.vue";

export default {
  name: "SocialProof",
  components: {
    TestimonialCard,
  },
  props: {
    testimonials: {
      type: Array,
      required: true,
      validator: (value) =>
        value.every((item) => typeof item === "object" && item.quote),
    },
  },
};
</script>

<style scoped>
.organism-social-proof {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 10rem 5rem;
  background-color: #fff;
}

.main-title {
  font-size: 3rem;
  margin-bottom: 2rem;
  font-weight: bold;
  text-align: center;
  color: #000;
}

.vision-description {
  font-size: 1.2rem;
  padding: 1rem 2rem;
  color: #7e7e7e;
  width: 75%;
  max-width: 800px;
  margin: 0 auto 4rem;
  text-align: center;
}

.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
}

@media (max-width: 1200px) {
  .testimonials-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }
}

@media (max-width: 768px) {
  .organism-social-proof {
    padding: 5rem 1rem;
  }

  .main-title {
    font-size: 2rem;
    margin-bottom: 2.5rem;
    font-weight: bold;
  }

  .vision-description {
    width: 100%;
    padding: 0;
  }

  .testimonials-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    max-width: 500px;
  }
}
</style>
